import { Chip, Menu, MenuItem } from '@mui/material'
import { useCallback, useState } from 'react'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { EntryWithRelated } from '../../models/inspections'
import { useUpdateInspectionEntryMutation } from '../../redux/api/inspectionApi'
import { EntryInfoStatusEnum } from '../../sdk'

export const AddressChip = ({
  inspectionEntry
}: {
  inspectionEntry: EntryWithRelated
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const { accessToken } = useAccessTokenAndShopId()
  const [updateEntry, { isLoading: loadingUpdateEntry }] =
    useUpdateInspectionEntryMutation()
  const handleMarkAddressed = useCallback(
    (markAsAddressed: boolean) => {
      updateEntry({
        authorization: accessToken,
        entryEntry: {
          id: inspectionEntry.id!,
          info: {
            ...inspectionEntry.info!,
            addressed: markAsAddressed ? new Date() : undefined
          }
        }
      })
      setAnchorEl(null)
    },
    [accessToken, inspectionEntry.id, inspectionEntry.info, updateEntry]
  )
  const handleOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  return (
    <>
      {inspectionEntry.status.info?.title !== EntryInfoStatusEnum.Passed && (
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={!!anchorEl}
          onClose={() => setAnchorEl(null)}>
          <MenuItem
            onClick={(event) => {
              event.stopPropagation()
              handleMarkAddressed(true)
            }}>
            Addressed
          </MenuItem>
          <MenuItem
            onClick={(event) => {
              event.stopPropagation()
              handleMarkAddressed(false)
            }}>
            Not Addressed
          </MenuItem>
        </Menu>
      )}
      {inspectionEntry.info!.addressed ||
      (inspectionEntry.status && !inspectionEntry.status.info!.shop) ? (
        <Chip
          label="Addressed"
          color="success"
          onClick={handleOpen}
          disabled={loadingUpdateEntry}
        />
      ) : (
        <Chip
          label="Not Addressed"
          color="warning"
          onClick={handleOpen}
          disabled={loadingUpdateEntry}
        />
      )}
    </>
  )
}
